import { render, staticRenderFns } from "./JustificationEdit.vue?vue&type=template&id=97ea3df0"
import script from "./JustificationEdit.vue?vue&type=script&lang=js"
export * from "./JustificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports